import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const refulfillmentTimeSeriesDataPointSchema_ = z.object({
  date: z.string(),
  orderCount: z.number(),
  revenueRecovered: z.number(),
  avgDeliveryDays: z.number().nullable(),
});
export const refulfillmentTimeSeriesDataPointSchema: z.ZodType<RefulfillmentTimeSeriesDataPoint> =
  refulfillmentTimeSeriesDataPointSchema_;
export interface RefulfillmentTimeSeriesDataPoint extends z.infer<
  typeof refulfillmentTimeSeriesDataPointSchema_
> {}

const latestRefulfillmentOrderSchema_ = z.object({
  orderName: z.string(),
  customerName: z.string().nullable(),
  totalAmount: z.number(),
  currency: z.string(),
  fulfilledAt: z.date(),
  itemCount: z.number(),
  trackingStatus: z.string().nullable(),
});
export const latestRefulfillmentOrderSchema: z.ZodType<LatestRefulfillmentOrder> =
  latestRefulfillmentOrderSchema_;
export interface LatestRefulfillmentOrder extends z.infer<
  typeof latestRefulfillmentOrderSchema_
> {}

const returnsCenterLocationSchema_ = z.object({
  id: z.string(),
  name: z.string(),
});
export const returnsCenterLocationSchema: z.ZodType<ReturnsCenterLocation> =
  returnsCenterLocationSchema_;
export interface ReturnsCenterLocation extends z.infer<
  typeof returnsCenterLocationSchema_
> {}

export const getRefulfillmentMetrics = unaryRpc({
  name: "getRefulfillmentMetrics" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    returnsCenterId: z.string().optional(),
  }),
  output: z.object({
    orderCount: z.number(),
    revenueRecovered: z.number(),
    avgDeliveryDays: z.number().nullable(),
    avgReturnToRefulfillmentDays: z.number().nullable(),
    ordersOverTime: z.array(refulfillmentTimeSeriesDataPointSchema),
    returnsCenterLocations: z.array(returnsCenterLocationSchema),
    omsLocationFilterIds: z.array(z.string()),
  }),
});

export type RefulfillmentMetricsOutput = z.infer<
  (typeof getRefulfillmentMetrics)["output"]
>;
